/**
 * Test environment: base config only (no local overrides).
 * Used when environment.base.ts is replaced by this file (configuration=test).
 */
export const environmentBase = {
  production: false,
  auth: {
    domain: 'auth.legalresources.com',
    audience: 'https://api.test.legalresources.com',
    redirectUri: window.location.origin + '/callback',
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    connection: 'email', // Passwordless email authentication
    portalKey: '' // Will be overridden by each portal ("client" | "member" | "attorney")
  },
  apiUrl: 'https://api.test.legalresources.com/v1'
};
